// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./variables.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/calendar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    line-height: 1.15;
    text-size-adjust: 100%;
}

body {
    margin: 0;
    font-family: 'Open Sans', 'Helvetica', sans-serif;
    font-size: 95%;
    line-height: 1.45;
    text-size-adjust: 100%;
    color: var(--gray-font);
    scroll-behavior: smooth;
}

button,
input,
optgroup,
select,
textarea {
    margin: 0;
    font: inherit;
}

button,
input {
    overflow: visible;
}

button,
select {
    text-transform: none;
}

img {
    border-style: none;
}

h1,
h2,
h3,
h4,
h5 {
    font-weight: 700;
    color: var(--gray-heading);
}

h1 {
    font-size: 28px;
    line-height: 32px;
}

h2 {
    font-size: 21px;
    line-height: 26px;
}

h3 {
    font-size: 18px;
    line-height: 26px;
}

@media (min-width: 768px) {
    h1 {
        font-size: 48px;
        line-height: 58px;
    }

    h2 {
        font-size: 26px;
        line-height: 32px;
    }

    h3 {
        font-size: 20px;
        line-height: 26px;
    }
}

ul {
    padding-inline-start: 20px;
}

a {
    color: var(--green);
}

label {
    cursor: pointer;
}

button {
    cursor: pointer;
}

button:disabled {
    cursor: default;
}

header {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-top: 8px solid var(--green);
    background-color: var(--gray-header-background);
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
}

main {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

footer {
    text-align: center;
    padding: 45px 0;
}

footer span {
    background-color: var(--white);
    padding: 24px 45px;
}

footer::after {
    display: block;
    content: '';
    border: 1px solid var(--light-gray);
    margin-top: -32px;
}

@media (min-width: 768px) {
    footer {
        padding: 24px 0;
    }

    footer span {
        padding: 24px 120px;
    }
}

.content {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
    max-width: 900px;
}

label.title,
.label {
    display: block;
    font-weight: 600;
    font-size: 16px;
    margin-top: 27px;
    line-height: 27px;
}

input[type='radio'],
input[type='checkbox'] {
    width: 18px;
    height: 18px;
    accent-color: var(--green);
    vertical-align: sub;
    margin-right: 8px;
}

input[type='submit'] {
    padding: 13px 33px;
    box-sizing: border-box;
    border: 2px solid var(--green);
    background: var(--green);
    color: var(--white);
    cursor: pointer;
}

input[type='text'] {
    box-sizing: border-box;
}

textarea {
    resize: none;
    width: 100%;
    height: 8rem;
    box-sizing: border-box;
}

.react-datepicker {
    border-radius: 2px;
    color: var(--gray-font);
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
    color: var(--gray-font);
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
    color: var(--gray-heading);
}

.react-datepicker__input-container > input {
    border-radius: 2px;
    border: 1px solid var(--light-gray);
    height: 40px;
    margin: 1px;
    padding: 2px 40px 2px 8px;
    background: no-repeat right 50% / 20% 60% url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.react-datepicker__input-container > input.invalid_date {
    border: 2px solid var(--red-error);
    margin: 0;
}

.react-datepicker__triangle {
    display: none;
}

.react-datepicker__header {
    background-color: var(--gray-header-background);
}

.react-datepicker-popper[data-placement^='bottom'] {
    padding-top: 2px;
}

.react-datepicker-popper[data-placement^='top'] {
    padding-bottom: 0;
    margin-bottom: -4px;
}

.skip-to-content {
    height: 1em;
    line-height: 1em;
    left: 50%;
    padding: 8px;
    position: absolute;
    transform: translateY(-100%);
    transition: transform 0.3s;
    border-radius: 4px;
    background: var(--white);
}

.skip-to-content:focus {
    transform: translateY(0%);
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAGA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,iDAAiD;IACjD,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;;;;;IAKI,SAAS;IACT,aAAa;AACjB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;;;IAKI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kCAAkC;IAClC,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;IAC9B,wBAAwB;IACxB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;;;IAGI,uBAAuB;AAC3B;;AAEA;;;IAGI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,iFAAmE;AACvE;;AAEA;IACI,kCAAkC;IAClC,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,0BAA0B;IAC1B,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,600');\n@import './variables.css';\n\nhtml {\n    line-height: 1.15;\n    text-size-adjust: 100%;\n}\n\nbody {\n    margin: 0;\n    font-family: 'Open Sans', 'Helvetica', sans-serif;\n    font-size: 95%;\n    line-height: 1.45;\n    text-size-adjust: 100%;\n    color: var(--gray-font);\n    scroll-behavior: smooth;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n    margin: 0;\n    font: inherit;\n}\n\nbutton,\ninput {\n    overflow: visible;\n}\n\nbutton,\nselect {\n    text-transform: none;\n}\n\nimg {\n    border-style: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5 {\n    font-weight: 700;\n    color: var(--gray-heading);\n}\n\nh1 {\n    font-size: 28px;\n    line-height: 32px;\n}\n\nh2 {\n    font-size: 21px;\n    line-height: 26px;\n}\n\nh3 {\n    font-size: 18px;\n    line-height: 26px;\n}\n\n@media (min-width: 768px) {\n    h1 {\n        font-size: 48px;\n        line-height: 58px;\n    }\n\n    h2 {\n        font-size: 26px;\n        line-height: 32px;\n    }\n\n    h3 {\n        font-size: 20px;\n        line-height: 26px;\n    }\n}\n\nul {\n    padding-inline-start: 20px;\n}\n\na {\n    color: var(--green);\n}\n\nlabel {\n    cursor: pointer;\n}\n\nbutton {\n    cursor: pointer;\n}\n\nbutton:disabled {\n    cursor: default;\n}\n\nheader {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    border-top: 8px solid var(--green);\n    background-color: var(--gray-header-background);\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 0 20px;\n}\n\nmain {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\nfooter {\n    text-align: center;\n    padding: 45px 0;\n}\n\nfooter span {\n    background-color: var(--white);\n    padding: 24px 45px;\n}\n\nfooter::after {\n    display: block;\n    content: '';\n    border: 1px solid var(--light-gray);\n    margin-top: -32px;\n}\n\n@media (min-width: 768px) {\n    footer {\n        padding: 24px 0;\n    }\n\n    footer span {\n        padding: 24px 120px;\n    }\n}\n\n.content {\n    box-sizing: border-box;\n    padding: 20px;\n    width: 100%;\n    max-width: 900px;\n}\n\nlabel.title,\n.label {\n    display: block;\n    font-weight: 600;\n    font-size: 16px;\n    margin-top: 27px;\n    line-height: 27px;\n}\n\ninput[type='radio'],\ninput[type='checkbox'] {\n    width: 18px;\n    height: 18px;\n    accent-color: var(--green);\n    vertical-align: sub;\n    margin-right: 8px;\n}\n\ninput[type='submit'] {\n    padding: 13px 33px;\n    box-sizing: border-box;\n    border: 2px solid var(--green);\n    background: var(--green);\n    color: var(--white);\n    cursor: pointer;\n}\n\ninput[type='text'] {\n    box-sizing: border-box;\n}\n\ntextarea {\n    resize: none;\n    width: 100%;\n    height: 8rem;\n    box-sizing: border-box;\n}\n\n.react-datepicker {\n    border-radius: 2px;\n    color: var(--gray-font);\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n    color: var(--gray-font);\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n    color: var(--gray-heading);\n}\n\n.react-datepicker__input-container > input {\n    border-radius: 2px;\n    border: 1px solid var(--light-gray);\n    height: 40px;\n    margin: 1px;\n    padding: 2px 40px 2px 8px;\n    background: no-repeat right 50% / 20% 60% url(/public/calendar.svg);\n}\n\n.react-datepicker__input-container > input.invalid_date {\n    border: 2px solid var(--red-error);\n    margin: 0;\n}\n\n.react-datepicker__triangle {\n    display: none;\n}\n\n.react-datepicker__header {\n    background-color: var(--gray-header-background);\n}\n\n.react-datepicker-popper[data-placement^='bottom'] {\n    padding-top: 2px;\n}\n\n.react-datepicker-popper[data-placement^='top'] {\n    padding-bottom: 0;\n    margin-bottom: -4px;\n}\n\n.skip-to-content {\n    height: 1em;\n    line-height: 1em;\n    left: 50%;\n    padding: 8px;\n    position: absolute;\n    transform: translateY(-100%);\n    transition: transform 0.3s;\n    border-radius: 4px;\n    background: var(--white);\n}\n\n.skip-to-content:focus {\n    transform: translateY(0%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
